import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { createAppConfig } from '@ui/shared/feature-config';
import type { MobilityMapItem } from './app/definitions/mobility-map-item';
import type { MobilityMapFilter } from './app/types/mobility-map-filters';
import { MobilityMapMapDataService } from './app/services/mobility-map-map-data.service';
import { SearchFilterConfigService } from './app/services/filter/search-filter-config.service';
import { GuidingThemesSelectFilterConfigService } from './app/services/filter/guiding-theme-select-filter-config.service';
import { TransportationTypeSelectFilterConfigService } from './app/services/filter/transportation-type-select-filter-config.service';
import { CategorySelectFilterConfigService } from './app/services/filter/category-select-filter-config.service';
import { ProjectsMapDataService } from './app/services/data/projects-map-data.service';

bootstrapApplication(AppComponent, createAppConfig<MobilityMapItem, MobilityMapFilter>({
    mapDataStateService: MobilityMapMapDataService,
    filterItems: [
        SearchFilterConfigService,
        GuidingThemesSelectFilterConfigService,
        TransportationTypeSelectFilterConfigService,
        CategorySelectFilterConfigService,
    ],
    dataEndpoints: [
        ProjectsMapDataService,
    ],
})).catch((err: unknown) => console.error(err));
